import { chatStore$ } from "@/lib/ContactsMap"
import { cyrb64Hash } from "@/lib/crypto.utils"
import type { TContact, TInteraction } from "@/schemas/contacts"
import { TRing, TUserStatus } from "@/schemas/user.schema"

export function generateContactFromInteractionOnError(contactID: string, interaction: TInteraction) {
  const newContact: TContact = {
    ContactPersonId: contactID,
    AccountId: interaction.AccountId,
    ContactCompanyName: interaction.ContactCompanyName ?? "",
    ContactEmail: interaction.ContactEmails?.[0],
    ContactEmails: interaction.ContactEmails ?? [],
    ContactFullname: interaction.ContactFullname ?? "",
    ContactPhoneNumber: interaction.ContactPhoneNumber,
    ContactRemoteJson: interaction.ContactRemoteJson,
    SearchTerm: "",
    LastTimestamp: Date.now(),
    ContactPhoneNumbers: [],
    ContactDNC: false,
    Occurrences: 0,
    Note: "",
    TTL: 0,
  }

  newContact.Hash = cyrb64Hash(JSON.stringify(newContact))

  chatStore$.contacts[contactID].set(newContact)
}

export function generateContactFromUserStatusAndRing(contactID: string, userStatus: TUserStatus, ring: TRing) {
  const newContact: TContact = {
    ContactPersonId: contactID,
    AccountId: userStatus.accountId.toString(),
    ContactCompanyName: "",
    ContactEmails: [],
    ContactFullname: ring.other?.name ?? "",
    ContactPhoneNumber: ring.other?.number ?? "",
    SearchTerm: "",
    LastTimestamp: Date.now(),
    ContactPhoneNumbers: [],
    ContactDNC: false,
    Occurrences: 0,
    Note: "",
    TTL: 0,
  }

  newContact.Hash = cyrb64Hash(JSON.stringify(newContact))

  chatStore$.contacts[contactID].set(newContact)
}
